module.exports = __webpack_public_path__ + "2577253f8a8bc50f4d0bc4b1df3b7bdd.svg";